import React, { Component } from 'react';
import { Container, Grid, Segment, Header, Table, Label, Button, Image, List, Icon, Loader, Message, MessageHeader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import Moment from 'moment';

import {
    deleteInpatientClaims,
    getSingleInpatientClaim,
    deleteInpatientIdClaims,
    getSingleInpatientIdClaim,
    getUnsubmittedClaimAttachment,
    getClaimOptionsEclaim,
    getSettlementLetter
} from '../../actions';
import DeleteClaimModal from '../../component/claim/delete_claim_modal';
import ClaimStatusLabel from '../../component/claim/claim_status_label';

class ClaimDetailInpPage extends Component {
    state = {
        selectedAttachmentId: null,
        viewUrl: null,
        openDeleteDialog: false,
        processingClaim:[],
        deleteThisClaim: false,
        deleteThisClaimResult: null,
        mimeType: null,
        pdfLoading: false,
        alertMessage: null,
        visitNo: null
    };
    componentDidMount() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        const claimProcessStatus = this.props.match.params.claimStatus;
        var selectedItemIndex = this.props.claims.findIndex( item => item.tx === claimTransactionNo );

        if (selectedItemIndex == -1) {
            return;
        }
        
        var selectedItem = this.props.claims[selectedItemIndex];
        
        var selectedNric = this.props.claims.filter( item => item.tx === claimTransactionNo )
        const selectedCompanyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId

        if (!this.props.claimOptions.inpatientClaimOptions) {
            this.props.getClaimOptionsEclaim(this.props.user.accessToken, selectedCompanyId);
        } 
        if(claimProcessStatus && claimProcessStatus === "PROCESSING"){
            selectedNric = this.props.claims.filter( item => item.id === claimTransactionNo )
        }
        if(claimProcessStatus && claimProcessStatus === "PROCESSING"){
            this.props.getSingleInpatientIdClaim({accessToken: this.props.user.accessToken, nric: selectedNric[0].ic, claimId: claimTransactionNo, companyId : selectedCompanyId, useRecordId: selectedItem.did ? selectedItem.did : selectedItem.eid ? selectedItem.eid : null}).then(() => {
                    const selectedClaim = this.props.viewedClaims[claimTransactionNo]
                    
                    for (let i = 0; i < selectedClaim.attachment.length; i++) {
                        let claimAttached = [];
                        let claimAttachmentStore = this.state.processingClaim;
                        let onlyAttached = {};
                        if(this.props.claimAttachment && this.props.claimAttachment.length>0){
                            claimAttached = this.props.claimAttachment.filter( item => item.objectId === selectedClaim.attachment[i].filename )
                            if(claimAttached && claimAttached.length > 0){
                                onlyAttached.viewUrl = claimAttached[0].attachmentLink
                                onlyAttached.filename = selectedClaim.attachment[i].filename
                                onlyAttached.mimeType = selectedClaim.attachment[i].mimeType
                                onlyAttached.loaded = true
                                claimAttachmentStore.push(onlyAttached);
                                this.setState({
                                    processingClaim: claimAttachmentStore
                                });

                            }else{
                            }
                        }
                        
                        if(claimAttached.length == 0){
                            this.setUnsubmittedAttachment(claimTransactionNo, selectedClaim.attachment[i]);
                        }
                    }
                });
        }
        else{
            this.props.getSingleInpatientClaim({
                accessToken: this.props.user.accessToken,
                // nric: this.props.user.nric,
                nric: selectedItem.ic,
                transactionNo: claimTransactionNo,
                companyId : selectedCompanyId,
                useRecordId: selectedItem.did ? selectedItem.did : selectedItem.eid ? selectedItem.eid : null
            });
        }
        if(selectedNric.length){
            this.setState({
                visitNo: selectedNric[0].vn
            })
        }
        
    }
    setUnsubmittedAttachment(claimTransactionNo, onlyAttached) {
        const selectedClaim = this.props.viewedClaims[claimTransactionNo]
        let attachedRetrieved = {}
        this.props.getUnsubmittedClaimAttachment({accessToken: this.props.user.accessToken, attchId: onlyAttached.filename, id: claimTransactionNo, mimeType: onlyAttached.mimeType}).then(() => {
            attachedRetrieved.viewUrl = this.props.claimSingleAttachment.attachmentLink
            attachedRetrieved.filename = onlyAttached.filename
            attachedRetrieved.mimeType = onlyAttached.mimeType
            attachedRetrieved.loaded = true
            let storedAttachments = this.state.processingClaim
            storedAttachments.push(attachedRetrieved)
            this.setState({
                processingClaim: storedAttachments
            });
        });
    }
    setSelectedAttachmentId(attachmentId, viewUrl, status, claimId, mimeType, original_filename) {
        let claimAttached = null
        if(status === 'PROCESSING'){
            claimAttached = this.props.claimAttachment.filter( item => item.objectId === attachmentId )
            if(claimAttached.length > 0){
                this.setState({
                selectedAttachmentId: attachmentId, 
                viewUrl: claimAttached[0].attachmentLink});
            }
            
        }else{
            this.setState({selectedAttachmentId: attachmentId, viewUrl, mimeType: original_filename.slice(-3)});
        }
    }
    renderStatusImage(status) {
        switch(status) {
            case "Rejected":
                return 'https://png.pngtree.com/svg/20170814/status_rejected_684182.png';
            case "Approved":
                return 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678134-sign-check-128.png';
            default:
                return 'https://cdn4.iconfinder.com/data/icons/computer-parts/512/refresh-512.png';
        }
    }
    renderAttachmentList(attachments, claimId, status) {
        return _.map(attachments, (attachment, index) => {
            const { filename, viewUrl, mimeType, original_filename } = attachment;
            const extension = original_filename.substr(original_filename.lastIndexOf(".") + 1).toUpperCase();
            let label;
            if (extension == 'JPG' || extension == 'PNG' || extension == 'GIF') {
                label = 'IMG'
            } else if (extension == 'PDF' || extension == 'DOC' || extension == 'DOCX') {
                label = 'FILE'
            } else {
                label = 'OTHER'
            }
            return (
                <List.Item key={filename}>
                    <List.Content floated='right'>
                        <Button
                            onClick={() => this.setSelectedAttachmentId(filename, viewUrl,status, claimId, mimeType, original_filename)}
                            disabled={this.state.selectedAttachmentId === filename}
                        >
                            View
                        </Button>
                    </List.Content>
                    <List.Content>
                        <Label color='red' horizontal>
                            {label}
                        </Label>
                        Uploaded Document {index + 1}
                    </List.Content>
                </List.Item>
            );
        });
    }
    renderSelectedAttachment() {
        if (this.state.selectedAttachmentId && this.state.viewUrl) {
            if(this.state.mimeType === 'pdf'){
            return (
                <iframe
                    src={this.state.viewUrl} 
                    width="100%"
                    height="850"
                    frameBorder="0"
                />
            );} else {
                return (
                    <Image src={this.state.viewUrl} />
                );
            }
        }
    }
    handleOpenDeleteDialog(openDeleteDialog) {
        if (openDeleteDialog === false) {
            this.setState({openDeleteDialog, deleteThisClaim: false, deleteThisClaimResult: null});
        } else {
            this.setState({openDeleteDialog});
        }
    }
    handleDeleteDecision() {
        // Proceed to delete the claim
        // 1 - Set isDeleting to true > this will render loader on modal and disable butons
        this.setState({deleteThisClaim: true, deleteThisClaimResult: null});
        // 2 - start request to delete claim
        const accessToken = this.props.user.accessToken;
        const transactionNo = this.props.match.params.claimTransactionNo;
        const claimProcessStatus = this.props.match.params.claimStatus;
        const selectedCompanyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId;
        if(claimProcessStatus && claimProcessStatus === "PROCESSING"){
            this.props.deleteInpatientIdClaims({claimId:transactionNo, accessToken, selectedCompanyId}, (result) => {
                if (result === true) {
                    this.setState({deleteThisClaimResult: true});
                } else {
                    this.setState({deleteThisClaimResult: false});
                }
            });
        }else{
            this.props.deleteInpatientClaims({transactionNo, accessToken, selectedCompanyId}, (result) => {
                if (result === true) {
                    this.setState({deleteThisClaimResult: true});
                } else {
                    this.setState({deleteThisClaimResult: false, deleteThisClaim: false});
                }
            });            
        }

    }
    handleOpenPdf = (base64String, transactionNo, visitNo) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `Settlement_${visitNo}_${transactionNo}.pdf`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // window.open(blobUrl);

        setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
        }, 100);
    };    

    ViewSettlementLetter(transactionNo, visitNo) {
        const { getSettlementLetter, user, match } = this.props;
        this.setState({ pdfLoading: true });
        getSettlementLetter(user.accessToken, user.nric, user.companyDetail.policyNo, match.params.claimTransactionNo)
            .then(({ payload }) => {
                this.handleOpenPdf(payload, transactionNo, visitNo);
                this.setState({ pdfLoading: false });
            })
            .catch(error => {
                console.error("Error fetching settlement letter:", error);
                this.setState({ 
                    pdfLoading: false,
                    alertMessage: error.errorMessage || 'Settlement Letter is not available'
                });
            });
    }

    render() {
        // console.log(this.props);
        // console.log('-->', this.props.match.params.claimTransactionNo);
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        const companyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId;
        const filteredCompany = this.props.user.companies.filter(company => company.companyId == companyId);
        const companyName = filteredCompany[0].companyName;
        // const selectedInpatientClaim = _.find(this.props.inpatientClaims, (claim) => claim.transactionNo === claimTransactionNo);
        const selectedInpatientClaim = this.props.viewedClaims[claimTransactionNo];
        if (!selectedInpatientClaim) {
            return (
                <Loader active />
            );
        }
        if(selectedInpatientClaim.status === "PROCESSING" && this.state.processingClaim && this.state.processingClaim.length !==selectedInpatientClaim.attachment.length){
            return (
                <Loader active />
            );
        }
        const {
            transactionNo,
            status,
            remarks,
            admissionDate,
            dischargeDate,
            reasonForTreatment,
            nameOfOperation,
            originalAmount,
            payableAmount,
            providerName,
            attachment,
            name,
            claimDocumentUrl,
            nric,
            empSubRemarks,
            symptoms,
            symptomsStartDate,
            batchNo
        } = selectedInpatientClaim;
        const isEditable = (status === 'Submitted' || status === 'Pending' || status === 'Pending Review' || status === 'PROCESSING') ? true : false;
        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                {(transactionNo) ? "Claim Details - " + transactionNo : "Claim Details "}
                </Header>
                <Segment>
                    <Link to="/app/claimrecords">
                        <Button>Back to Claim Records</Button>
                    </Link>
                    <Link to={`/app/askjoey?type=inpclaim&id=${claimTransactionNo}`}>
                        <Button>Chat with an adminstrator regarding this claim</Button>
                    </Link>
                    {
                        (isEditable === true) ?
                        (
                            <Link to={`/app/claimrecords/inp/${claimTransactionNo}/update?claimStatus=${status}`}>
                                <Button
                                    disabled={false}
                                >
                                    <Icon name="edit" />
                                    Update information regarding this claim
                                </Button>
                            </Link>
                        )
                        :
                        (
                            <Button
                                disabled={true}
                            >
                                <Icon name="edit" />
                                Update information regarding this claim
                            </Button>
                        )
                    }
                    {
                        (batchNo && (status === 'Approved' || status === 'Rejected')) &&
                        <Button
                            onClick={() => this.ViewSettlementLetter(transactionNo, this.state.visitNo)}
                            disabled={this.state.pdfLoading}>
                            <Icon name="file alternate outline" />
                            Download Settlement Letter
                            {this.state.pdfLoading && <Loader className="ms-2" size="sm" variant="border" />}
                        </Button>
                        }
                    <DeleteClaimModal
                        open={this.state.openDeleteDialog}
                        handleOpenDeleteDialog={this.handleOpenDeleteDialog.bind(this)}
                        status={status}
                        transactionNo={transactionNo}
                        handleDeleteDecision={this.handleDeleteDecision.bind(this)}
                        deleteThisClaim={this.state.deleteThisClaim}
                        deleteThisClaimResult={this.state.deleteThisClaimResult}
                    />
                    {
                        this.state.alertMessage &&
                        <Message negative>
                            <MessageHeader>{this.state.alertMessage}</MessageHeader>
                        </Message>
                    }
                </Segment>
                <Grid columns={2}>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Status
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Status
                                        </Table.Cell>
                                        <Table.Cell>
                                            <ClaimStatusLabel status={status} />
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Remarks
                                        </Table.Cell>
                                        <Table.Cell>
                                            {remarks}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Header as='h4' attached='top' block>
                            Claimant
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    {this.props.user.companies.length > 1 && 
                                    <Table.Row>
                                        <Table.Cell>
                                            Company
                                        </Table.Cell>
                                        <Table.Cell>
                                            {companyName}
                                        </Table.Cell>
                                    </Table.Row>}
                                    <Table.Row>
                                        <Table.Cell>
                                            Name
                                        </Table.Cell>
                                        <Table.Cell>
                                            {name}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            NRIC
                                        </Table.Cell>
                                        <Table.Cell>
                                            {nric}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Header as='h4' attached='top' block>
                            Claim Details
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Transaction No
                                        </Table.Cell>
                                        <Table.Cell>
                                            {transactionNo}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Incurred Amount
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Label color='green' horizontal>
                                                {originalAmount.currency}
                                            </Label>
                                            {Math.round(originalAmount.amount).toFixed(2)}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Payable Amount
                                        </Table.Cell>
                                        {
                                          (status.toLowerCase() === 'submitted')
                                          &&
                                          <Table.Cell>
                                            {'Pending'}
                                          </Table.Cell>
                                        }
                                        {
                                          (status.toLowerCase() === 'pending')
                                          &&
                                          <Table.Cell>
                                            {'Pending'}
                                          </Table.Cell>
                                        }
                                        {
                                          (status.toLowerCase() === 'processing')
                                          &&
                                          <Table.Cell>
                                            {'Pending'}
                                          </Table.Cell>
                                        }
                                        {
                                          (status.toLowerCase() === 'approved')
                                          &&
                                          <Table.Cell>
                                            <div>
                                                <Label color='green' horizontal>
                                                    {/* {originalAmount.currency} */}
                                                    {"SGD"}
                                                </Label>
                                                {payableAmount}
                                            </div>
                                          </Table.Cell>
                                        }
                                        {
                                          (status.toLowerCase() === 'rejected')
                                          &&
                                          <Table.Cell>
                                            <div>
                                                <Label color='green' horizontal>
                                                    {originalAmount.currency}
                                                </Label>
                                                {'0'}
                                            </div>
                                          </Table.Cell>
                                        }
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Hospital
                                        </Table.Cell>
                                        <Table.Cell>
                                            {providerName}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Admission Date
                                        </Table.Cell>
                                        <Table.Cell>
                                            { Moment(admissionDate, 'D/M/YYYY').format('DD MMM YYYY')}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Discharge Date
                                        </Table.Cell>
                                        <Table.Cell>
                                            { Moment(dischargeDate, 'D/M/YYYY').format('DD MMM YYYY')}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Diagnosis/Medical Condition
                                        </Table.Cell>
                                        <Table.Cell>
                                            {reasonForTreatment}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Descriptions of Symptoms
                                        </Table.Cell>
                                        <Table.Cell>
                                            {symptoms}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Date of the Symptoms Started
                                        </Table.Cell>
                                        <Table.Cell>
                                            { Moment(symptomsStartDate, 'D/M/YYYY').format('DD MMM YYYY')}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Name of Operation/Surgical Code
                                        </Table.Cell>
                                        <Table.Cell>
                                            {nameOfOperation}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Remarks
                                        </Table.Cell>
                                        <Table.Cell>
                                            {empSubRemarks || 'No Remarks'}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment.Group>
                            <Header as='h4' attached='top' block>
                                Documents
                            </Header>
                            <Segment attached>
                                <List divided>
                                    {this.renderAttachmentList(attachment, claimTransactionNo, status)}
                                </List>
                            </Segment>
                            <Segment attached>
                                {this.renderSelectedAttachment()}
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        inpatientClaims: state.claims.inpatientClaims,
        user: state.user.user,
        viewedClaims: state.claims.viewed,
        claimAttachment: state.claims.claimImage,
        claimSingleAttachment: state.claims.claimSingleImage,
        claimOptions: state.claimOptions,
        claims: state.claims.data,
        claimFilterOptions: state.claims.filterOptions,
    }
}

export default connect(mapStateToProps, {deleteInpatientClaims, getSingleInpatientClaim, deleteInpatientIdClaims, getSingleInpatientIdClaim, getUnsubmittedClaimAttachment, getClaimOptionsEclaim, getSettlementLetter})(ClaimDetailInpPage);
